
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as labsHKjhBpNwhpvFe01Xww_45Q_452MgMD6z4Erm0VI5z_45Zn9O0Meta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/labs.vue?macro=true";
import { default as colabiCRHn6d5zBSOmKxk6IPcSimv8n_45jkSdhkH_45NPwuhMt4Meta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/colab.vue?macro=true";
import { default as error4_456ZoFGuyKhDk_KgdRTGL83_NdGcMq7BqX_IlEaNQF4Meta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/error.vue?macro=true";
import { default as indexV08jfmpiN3jnvPy0FiJIZoM6ppvNVr0E7KZLqR2tR_wMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/index.vue?macro=true";
import { default as indexQ2SAbY0yZ_45OPsIkL_45PvjdNuYWQyibnU0L1186pCpYHYMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/launch/index.vue?macro=true";
import { default as indexhgyHEmbg8OcxphqNr4sTH6iwcFUFSvmjbDiUTAFqmkAMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/launch/status/index.vue?macro=true";
import { default as quick_45launch_45status5F4l_45q93zqa_JOU03hgL9H3cEntNt6u9YnD5yEZjb3cMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/launch/quick-launch-status.vue?macro=true";
import { default as launch2jRrz6FFwSND9wCntEiVqAQK4qQJAW92JqIiQYjs_XUMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/launch.vue?macro=true";
import { default as indexF_45g7pZ7RgeJSdD9CjlVeQyw2OrWTJPRy3LnHnMOnvFcMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/manage/index.vue?macro=true";
import { default as _91manageType_93Gg8lxH8UcmyeTNvHGXYXzSYbxANFqu3byNEY5CDoRBwMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/manage/[manageType].vue?macro=true";
import { default as indexPgzYOWi6MSM7UNCkJInWDaG4TaeNGfcOO6mPJ8u1f5wMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/manage/create/index.vue?macro=true";
import { default as manageRh5NcEYGPLiOjv3b5ppEndptUn3p2b_80OK6L4Y9otcMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/manage.vue?macro=true";
import { default as statusXKfKSPcgg_5LiilZ_45QyYMBGnj7L46h30EiFQn2s1TGEMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/status.vue?macro=true";
import { default as api_45docb020bsZUvi_459WJGa8yxHFSpzVbrLPupJ2soAlA5Ci7EMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/api-doc.vue?macro=true";
import { default as indexO2USqHLgleOlfNCbFPZ1CLy5uGJOBSNfA2fKJTcZmQoMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/welcome/index.vue?macro=true";
import { default as welcomeJkrHENe1KlZsmSyEQJBS_45pS4VMf226NmQosby3hoSfcMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/welcome.vue?macro=true";
import { default as bulk_45editwcJH8hpBESI_I0g__F0xTj5V3Hm3rVVYKr0n7nNC70YMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/bulk-edit.vue?macro=true";
import { default as html5_45ads6R9d38NvgF71a1rm_S__45YMs4zcDLYzNsUyeymCOgbD0Meta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/html5-ads.vue?macro=true";
import { default as video_45ads_L5jP06tReCY5duNJ_v5meDIvOAPU7EUnGu5O9W5wGgMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/video-ads.vue?macro=true";
import { default as indexiVMx51b5OtCt9Bwb8hbrFXo1nMH2HLvAxL_liYqC2t0Meta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/bulk/index.vue?macro=true";
import { default as deckHelperyJ2TaqbDv7aMJCqp5m4on6v4Ibsgjaci1WXxgKm0Z1EMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/deckHelper.vue?macro=true";
import { default as index_45kwmSGqBM_yz_Qy1SK0jd2SMJM0TMPrxYr33iPNl2RYMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/login/index.vue?macro=true";
import { default as office_45mateFsxTfv7DE0HdliLSLGGpRmyGz7grajM4WEUf4WcmtFwMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/office-mate.vue?macro=true";
import { default as index8j5bRusmLocb1g9mBx_45CcQfL2fUQpTzpr_45dCevMLLwsMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/setup/index.vue?macro=true";
import { default as indexnzekGysVLBFW87xtAOfaNrlKWjmvJWZGJJ_F0uzHPAcMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/style/index.vue?macro=true";
import { default as indexXM5bLAV6yrX2ghBdhJIjtTovP8japPkHs4O25J4ZzDgMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/alerts/index.vue?macro=true";
import { default as indexSVVk0sJRbQci1opCi3tLNs4oicMWqShq_VVs67EurNUMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/bionic/index.vue?macro=true";
import { default as receiptxENICHvzFt2U28gToAgIh9CFVgLR4AsmfZsJl_YAmWIMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/bulk/receipt.vue?macro=true";
import { default as form_45designerNMnS2ej4Wuki_fvQB0Mv4x5f_invQaeN_45xvw_SuAcIUMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/form-designer.vue?macro=true";
import { default as logsDhIdqdqF5sKCLmyLq2d1gAFxWXYRhcZd_45M46IK2khf4Meta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/logs.vue?macro=true";
import { default as logo2Sn9ezLG6N3ta3w138_45MpkuJkNyi2_45ceRwRePqgtVpMMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/logo.vue?macro=true";
import { default as vue3dOnarplvLUcVtSPozvRUIdC1rGjkXwyZS2IiCYS07YoMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/vue3.vue?macro=true";
import { default as dataxQJXOhdinmRUt17VsvqEk_Ywn_45C18LnXQbLdF0EKwa4Meta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/settings/data.vue?macro=true";
import { default as bionic2LiocfJRBu7RpBucHVg1YhD0Q1lC_45ugtkfwkgCDdrc6AMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/bionic/bionic2.vue?macro=true";
import { default as bionic374XLCWKlpvB0huojMMiBZqBZwH2LI25L3sqDBtzod9YMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/bionic/bionic3.vue?macro=true";
import { default as bionic49Ze0BgmP8eLvIoAwwg2auIusxr6KMr0sMTEzr9RoQlEMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/bionic/bionic4.vue?macro=true";
import { default as indexIi45_Vwx5CU942hW2DwHysk3CpyeHqDbCCaoMSLQ5GUMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/index.vue?macro=true";
import { default as page_45not_45foundJDrqLphiUH2vmu_45pNqEbRSTxZBGH_1d8RhG7KiDKeEcMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/page-not-found.vue?macro=true";
import { default as indextNZggkMtoknGc6khi05elqUW2eZU9hngbuy_45LmBhEV0Meta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/approvals/index.vue?macro=true";
import { default as indexvcKCjxCIgnxz23gkg_45JCGkdxCWOC5cRVjKTGiwTu5I0Meta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/dashboard/index.vue?macro=true";
import { default as indexC50K3iVZyNXEoP4zl056j5zZkC4zCF6LvIVK6ZtxPNEMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/reporting/index.vue?macro=true";
import { default as _91partner_93bSQ4BtGX_450caqEJR_CcotQnQf8a_45WULvUe6tBjqvDO0Meta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/setup/[partner].vue?macro=true";
import { default as index_45F8Hub5QfNkk_BBeUJnJsgobpWm2IBxROrceD76CrsQMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/blueprints/index.vue?macro=true";
import { default as crawler2Y7T9Zeea41uGHjv5KVh_2HRQUgfpIsoJuQQlgpEkU0Meta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/crawler.vue?macro=true";
import { default as ai_45helpm92rh4PM3eqbRaAXZyya94_45bdjE1JnNRTLysq8d58CQMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/ai-help.vue?macro=true";
import { default as sandboxtKGRmYbQFuIOqvDgqBJkG9Vu7BSydT9uGMPLkhoRRHkMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/sandbox.vue?macro=true";
import { default as fluencyaXLda_45uyytC_nhGUDMCSh9SwYT5GUZNev7E2KzWYTRkMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/settings/fluency.vue?macro=true";
import { default as config_45f9yRTjOw_45vZKBSAjiT0AYRZc3FT1SlxcApsMtyqY0cMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/blueprints/config.vue?macro=true";
import { default as feedbackXzDkhD0xTaC5zmolpPDt9mNnC_MubVlpH069byW9pzEMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/feedback.vue?macro=true";
import { default as api_45testJnKuBltjrMIL3lNM563PiED4JYC5SdlTSDskjza0WiAMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/api-test.vue?macro=true";
import { default as indexcilImZ_yT70IeeOEKBkCz36o7OV0Su2a2xRnWGuJFuMMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/prospecting/index.vue?macro=true";
import { default as billing1cUSvECMhAEVh7Mb0AhdxjX5WktxX3etQKVLPshiVtoMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/reporting/billing.vue?macro=true";
import { default as historyul5Vjx4NSTMgGM_45DDwOidu7B1vtyciIY9c_45iz86qIlUMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/reporting/history.vue?macro=true";
import { default as preview6LHIFqPfytbm__4FeanjglxAW7WAvyF33yI4ElVpUWgMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/reporting/preview.vue?macro=true";
import { default as customeruDF92rzWqHX_45QgpWgAXZY_5NjDAClT7x_LtpNqBOFA8Meta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/settings/customer.vue?macro=true";
import { default as broadcasth1dmKLOG472gW4Yr6CODwjky8fARaGsHwxzvdHfyiGsMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/customer/broadcast.vue?macro=true";
import { default as prime_45vuejAvabkM2t2AvdfclJL1_45O4x8zNbYuWBT8m_45VSFJfymIMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/prime-vue.vue?macro=true";
import { default as crawlerDataqyB8ApN3PlYsPKA3qZF5fIAEpmVBSwM_fu1pAj8_45PvQMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/account/crawlerData.vue?macro=true";
import { default as adRenderererXxW8bGNIsIogKp936jtY3dkpjYWj5SeXOfSqhVoswMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/adRenderer.vue?macro=true";
import { default as colab_45testSr5fn5RIgoUWgX9vmjpAL9ACNTT6hJYi7CsoSBTPnmAMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/colab-test.vue?macro=true";
import { default as smoke_45testLzTUqaaJp4v8vnq0TKIyqVjXdOw4TDwexyUIj8AzMGAMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/smoke-test.vue?macro=true";
import { default as chartRenderffvaqvwes2iTOYllCXNAd8Rj8CfbyjSmYRydDQzuBeoMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/chartRender.vue?macro=true";
import { default as drag_45n_45dropq0uRmTrqkLMNhgF9F7FEG3eROQgm7tEZmSNBUvmY41UMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/drag-n-drop.vue?macro=true";
import { default as style_45guideiy1gWfggx6lGikHefmmHIucS01FMgww_45POwF4lTU_4wMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/style-guide.vue?macro=true";
import { default as target_45setsoKOCVKchIrHpydJIcVwQRn3ngq1EIBrv45JJ3kYbwbYMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/settings/target-sets.vue?macro=true";
import { default as tag_45reviewH8vhZFQ1IUhCJSiOm_XNYH_45rueXRPOETscYUth9CR6sMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/blueprints/tag-review.vue?macro=true";
import { default as reverse_45syncvpiaYhHaiEcKDKd_45RUWtCWcPzAPpDuVXQZza8t4HHcAMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/reverse-sync.vue?macro=true";
import { default as dynamic_45formbhiqEmRMQHLdYVEnOduEfF32RR8NbiUvlSqmzHzQCrkMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/dynamic-form.vue?macro=true";
import { default as index28V2_GwasHRdkjuPRA0IjCvsHbR7oTPLD_a2XFTsZqUMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/alerts/anomalies/index.vue?macro=true";
import { default as budget_45groupsHrJQZXIWGtM5syhHDuukwfshtEpm7rbDmlBfgn8aD_45cMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/budget-groups.vue?macro=true";
import { default as peer_45insightsoDaLY0WtBgx9I9Rc_45RxGlMGIVuYFMF2wI_45Pnhc0C0D8Meta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/peer-insights.vue?macro=true";
import { default as colab_45manager2ZvJn4GApx2F2DKX2cszU_45j1d3nBuTX7VaI3viNt6jsMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/colab-manager.vue?macro=true";
import { default as change_45historyGuM2p3f4ovpPcI5isbykeVbd_45o3X5g0EBpbGVpA7ISgMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/change-history.vue?macro=true";
import { default as blueprint_45demo46cOrMxrvR2HqKYfh0mzToabHLrN0c5HIwap8AC5iS8Meta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/blueprint-demo.vue?macro=true";
import { default as dynamic_45reportADX2LMQi_45n8lGxxiXZ_45kwUaCdkXf7c_gHxdMZZN3V0QMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/dynamic-report.vue?macro=true";
import { default as layout_45buildervybuZmx2K_45csm4DBC8cm9x1r7MJv5r1YSp3Gat1GiQUMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/layout-builder.vue?macro=true";
import { default as data_45explorer0tvcuWfo73NLHr9KB1S60eWkSvLpQTT4mn50iGVODSYMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/reporting/data-explorer.vue?macro=true";
import { default as account_45ingestsy8qflmPOCykjRym0QEKehUUOl95fkjj0DqvetzzAQsMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/settings/account-ingest.vue?macro=true";
import { default as example_45widgetbEcvxq5FOWkTeDCWXhYie35YmvDPCZYPJTqMstV8_EsMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/dashboard/example-widget.vue?macro=true";
import { default as indexsc7wFeVK9XCAFjrzDAmnRJfx18zy1vmjeZ_WBbrDY_45wMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/customers/index.vue?macro=true";
import { default as shared_45audiences_45YYZ3PJCqfztcTvQNk1I710GS4ZIvMsqEZObAh1qdNYMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/settings/shared-audiences.vue?macro=true";
import { default as analyst_45scorecardpvf_I_45Y7AfPGH4u68Pum_45nIQ1nXcCXIwR5QIxy4Axt0Meta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/analyst-scorecard.vue?macro=true";
import { default as engineeringAuditCustomerBreakdownjmEjkBVC0uUr_454dFUFiQYi8JiITmufUuS_45I19bmTnekMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/engineering-audit/engineeringAuditCustomerBreakdown.vue?macro=true";
import { default as engineering_45auditkpWFoDflZDFbuhYcYJdaE2rM9ksvDidgHqcwMevvPJoMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/engineering-audit.vue?macro=true";
import { default as crawlSiteDetectorwOHsF2KJPnWkOb8Up9fBNEUYf9zftP2rWJ3rP_ZosNYMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/settings/crawlSiteDetector.vue?macro=true";
import { default as crawlerDebugBrowsereO9466pVbYbKhxtQKJNdnRX5hLRH3FPetKooOUPXEc4Meta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/account/crawlerDebugBrowser.vue?macro=true";
import { default as budget_45adjustmentslaoxvkRg2dSPU3vGMcgEV2VeZFO9IwoVB6KklvuelXkMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/budget-adjustments.vue?macro=true";
import { default as account_45performanceMK6Yd_M9YYcu6VCcNMestPCZ33cUVuYnWG55TlRtQvMMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/account-performance.vue?macro=true";
import { default as partner_45sync_45statusYDpDh0yWSyNfy5kMNJbmzbKgfPdD_45Sat2GZSFl0ZMGcMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/partner-sync-status.vue?macro=true";
import { default as blueprint_45tag_45languagedbazf2S_459TnnJwiL1o0GfZaF657RXqXEgqu0P2De6hIMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/blueprint-tag-language.vue?macro=true";
import { default as keyword_45recommendationsQaNzMuZzPpydUqjm6UlHiEKZgMiD0TXKIvRgfP7YalQMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/keyword-recommendations.vue?macro=true";
import { default as customerPackageSelectorCa6BvhKqS1MmWvWl7QacrScakUYCok1f0vMibW26qPMMeta } from "/home/staging/git/fluent-ui/apps/backpack/src/pages/settings/customerPackageSelector.vue?macro=true";
import { default as component_45stub3ce9d6BLMR4br3dwmImQ8nV6mBz6xVxIGsx6zr40rXwMeta } from "/home/staging/git/fluent-ui/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub3ce9d6BLMR4br3dwmImQ8nV6mBz6xVxIGsx6zr40rXw } from "/home/staging/git/fluent-ui/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "labs",
    path: "/labs",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/labs.vue")
  },
  {
    name: "colab",
    path: "/colab",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/colab.vue")
  },
  {
    name: "error",
    path: "/error",
    meta: error4_456ZoFGuyKhDk_KgdRTGL83_NdGcMq7BqX_IlEaNQF4Meta || {},
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/index.vue")
  },
  {
    name: launch2jRrz6FFwSND9wCntEiVqAQK4qQJAW92JqIiQYjs_XUMeta?.name,
    path: "/launch",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/launch.vue"),
    children: [
  {
    name: "launch",
    path: "",
    meta: indexQ2SAbY0yZ_45OPsIkL_45PvjdNuYWQyibnU0L1186pCpYHYMeta || {},
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/launch/index.vue")
  },
  {
    name: "launch-status",
    path: "status",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/launch/status/index.vue")
  },
  {
    name: "launch-quick-launch-status",
    path: "quick-launch-status",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/launch/quick-launch-status.vue")
  }
]
  },
  {
    name: manageRh5NcEYGPLiOjv3b5ppEndptUn3p2b_80OK6L4Y9otcMeta?.name,
    path: "/manage",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/manage.vue"),
    children: [
  {
    name: "manage",
    path: "",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/manage/index.vue")
  },
  {
    name: "manage-manageType",
    path: ":manageType()",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/manage/[manageType].vue")
  },
  {
    name: "manage-create",
    path: "create",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/manage/create/index.vue")
  }
]
  },
  {
    name: "status",
    path: "/status",
    meta: statusXKfKSPcgg_5LiilZ_45QyYMBGnj7L46h30EiFQn2s1TGEMeta || {},
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/status.vue")
  },
  {
    name: "api-doc",
    path: "/api-doc",
    meta: api_45docb020bsZUvi_459WJGa8yxHFSpzVbrLPupJ2soAlA5Ci7EMeta || {},
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/api-doc.vue")
  },
  {
    name: welcomeJkrHENe1KlZsmSyEQJBS_45pS4VMf226NmQosby3hoSfcMeta?.name,
    path: "/welcome",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/welcome.vue"),
    children: [
  {
    name: "welcome",
    path: "",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/welcome/index.vue")
  }
]
  },
  {
    name: "bulk-edit",
    path: "/bulk-edit",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/bulk-edit.vue")
  },
  {
    name: "html5-ads",
    path: "/html5-ads",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/html5-ads.vue")
  },
  {
    name: "video-ads",
    path: "/video-ads",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/video-ads.vue")
  },
  {
    name: "bulk",
    path: "/bulk",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/bulk/index.vue")
  },
  {
    name: "deckHelper",
    path: "/deckHelper",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/deckHelper.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: index_45kwmSGqBM_yz_Qy1SK0jd2SMJM0TMPrxYr33iPNl2RYMeta || {},
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/login/index.vue")
  },
  {
    name: "office-mate",
    path: "/office-mate",
    meta: office_45mateFsxTfv7DE0HdliLSLGGpRmyGz7grajM4WEUf4WcmtFwMeta || {},
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/office-mate.vue")
  },
  {
    name: "setup",
    path: "/setup",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/setup/index.vue")
  },
  {
    name: "style",
    path: "/style",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/style/index.vue")
  },
  {
    name: "alerts",
    path: "/alerts",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/alerts/index.vue")
  },
  {
    name: "bionic",
    path: "/bionic",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/bionic/index.vue")
  },
  {
    name: "bulk-receipt",
    path: "/bulk/receipt",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/bulk/receipt.vue")
  },
  {
    name: "form-designer",
    path: "/form-designer",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/form-designer.vue")
  },
  {
    name: "insights-logs",
    path: "/insights/logs",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/logs.vue")
  },
  {
    name: "internal-logo",
    path: "/internal/logo",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/logo.vue")
  },
  {
    name: "internal-vue3",
    path: "/internal/vue3",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/vue3.vue")
  },
  {
    name: "settings-data",
    path: "/settings/data",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/settings/data.vue")
  },
  {
    name: "bionic-bionic2",
    path: "/bionic/bionic2",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/bionic/bionic2.vue")
  },
  {
    name: "bionic-bionic3",
    path: "/bionic/bionic3",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/bionic/bionic3.vue")
  },
  {
    name: "bionic-bionic4",
    path: "/bionic/bionic4",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/bionic/bionic4.vue")
  },
  {
    name: "internal",
    path: "/internal",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/index.vue")
  },
  {
    name: "page-not-found",
    path: "/page-not-found",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/page-not-found.vue")
  },
  {
    name: "approvals",
    path: "/approvals",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/approvals/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/dashboard/index.vue")
  },
  {
    name: "reporting",
    path: "/reporting",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/reporting/index.vue")
  },
  {
    name: "setup-partner",
    path: "/setup/:partner()",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/setup/[partner].vue")
  },
  {
    name: "blueprints",
    path: "/blueprints",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/blueprints/index.vue")
  },
  {
    name: "insights-crawler",
    path: "/insights/crawler",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/crawler.vue")
  },
  {
    name: "internal-ai-help",
    path: "/internal/ai-help",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/ai-help.vue")
  },
  {
    name: "internal-sandbox",
    path: "/internal/sandbox",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/sandbox.vue")
  },
  {
    name: "settings-fluency",
    path: "/settings/fluency",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/settings/fluency.vue")
  },
  {
    name: "blueprints-config",
    path: "/blueprints/config",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/blueprints/config.vue")
  },
  {
    name: "insights-feedback",
    path: "/insights/feedback",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/feedback.vue")
  },
  {
    name: "internal-api-test",
    path: "/internal/api-test",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/api-test.vue")
  },
  {
    name: "prospecting",
    path: "/prospecting",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/prospecting/index.vue")
  },
  {
    name: "reporting-billing",
    path: "/reporting/billing",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/reporting/billing.vue")
  },
  {
    name: "reporting-history",
    path: "/reporting/history",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/reporting/history.vue")
  },
  {
    name: "reporting-preview",
    path: "/reporting/preview",
    meta: preview6LHIFqPfytbm__4FeanjglxAW7WAvyF33yI4ElVpUWgMeta || {},
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/reporting/preview.vue")
  },
  {
    name: "settings-customer",
    path: "/settings/customer",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/settings/customer.vue")
  },
  {
    name: "customer-broadcast",
    path: "/customer/broadcast",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/customer/broadcast.vue")
  },
  {
    name: "internal-prime-vue",
    path: "/internal/prime-vue",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/prime-vue.vue")
  },
  {
    name: "account-crawlerData",
    path: "/account/crawlerData",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/account/crawlerData.vue")
  },
  {
    name: "internal-adRenderer",
    path: "/internal/adRenderer",
    meta: adRenderererXxW8bGNIsIogKp936jtY3dkpjYWj5SeXOfSqhVoswMeta || {},
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/adRenderer.vue")
  },
  {
    name: "internal-colab-test",
    path: "/internal/colab-test",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/colab-test.vue")
  },
  {
    name: "internal-smoke-test",
    path: "/internal/smoke-test",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/smoke-test.vue")
  },
  {
    name: "internal-chartRender",
    path: "/internal/chartRender",
    meta: chartRenderffvaqvwes2iTOYllCXNAd8Rj8CfbyjSmYRydDQzuBeoMeta || {},
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/chartRender.vue")
  },
  {
    name: "internal-drag-n-drop",
    path: "/internal/drag-n-drop",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/drag-n-drop.vue")
  },
  {
    name: "internal-style-guide",
    path: "/internal/style-guide",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/style-guide.vue")
  },
  {
    name: "settings-target-sets",
    path: "/settings/target-sets",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/settings/target-sets.vue")
  },
  {
    name: "blueprints-tag-review",
    path: "/blueprints/tag-review",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/blueprints/tag-review.vue")
  },
  {
    name: "insights-reverse-sync",
    path: "/insights/reverse-sync",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/reverse-sync.vue")
  },
  {
    name: "internal-dynamic-form",
    path: "/internal/dynamic-form",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/dynamic-form.vue")
  },
  {
    name: "alerts-anomalies",
    path: "/alerts/anomalies",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/alerts/anomalies/index.vue")
  },
  {
    name: "insights-budget-groups",
    path: "/insights/budget-groups",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/budget-groups.vue")
  },
  {
    name: "insights-peer-insights",
    path: "/insights/peer-insights",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/peer-insights.vue")
  },
  {
    name: "internal-colab-manager",
    path: "/internal/colab-manager",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/colab-manager.vue")
  },
  {
    name: "insights-change-history",
    path: "/insights/change-history",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/change-history.vue")
  },
  {
    name: "internal-blueprint-demo",
    path: "/internal/blueprint-demo",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/blueprint-demo.vue")
  },
  {
    name: "internal-dynamic-report",
    path: "/internal/dynamic-report",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/dynamic-report.vue")
  },
  {
    name: "internal-layout-builder",
    path: "/internal/layout-builder",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/layout-builder.vue")
  },
  {
    name: "reporting-data-explorer",
    path: "/reporting/data-explorer",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/reporting/data-explorer.vue")
  },
  {
    name: "settings-account-ingest",
    path: "/settings/account-ingest",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/settings/account-ingest.vue")
  },
  {
    name: "dashboard-example-widget",
    path: "/dashboard/example-widget",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/dashboard/example-widget.vue")
  },
  {
    name: "internal-customers",
    path: "/internal/customers",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/customers/index.vue")
  },
  {
    name: "settings-shared-audiences",
    path: "/settings/shared-audiences",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/settings/shared-audiences.vue")
  },
  {
    name: "insights-analyst-scorecard",
    path: "/insights/analyst-scorecard",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/analyst-scorecard.vue")
  },
  {
    name: "internal-engineering-audit",
    path: "/internal/engineering-audit",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/engineering-audit.vue"),
    children: [
  {
    name: "internal-engineering-audit-engineeringAuditCustomerBreakdown",
    path: "engineeringAuditCustomerBreakdown",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/engineering-audit/engineeringAuditCustomerBreakdown.vue")
  }
]
  },
  {
    name: "settings-crawlSiteDetector",
    path: "/settings/crawlSiteDetector",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/settings/crawlSiteDetector.vue")
  },
  {
    name: "account-crawlerDebugBrowser",
    path: "/account/crawlerDebugBrowser",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/account/crawlerDebugBrowser.vue")
  },
  {
    name: "insights-budget-adjustments",
    path: "/insights/budget-adjustments",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/budget-adjustments.vue")
  },
  {
    name: "insights-account-performance",
    path: "/insights/account-performance",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/account-performance.vue")
  },
  {
    name: "insights-partner-sync-status",
    path: "/insights/partner-sync-status",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/partner-sync-status.vue")
  },
  {
    name: "internal-blueprint-tag-language",
    path: "/internal/blueprint-tag-language",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/internal/blueprint-tag-language.vue")
  },
  {
    name: "insights-keyword-recommendations",
    path: "/insights/keyword-recommendations",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/insights/keyword-recommendations.vue")
  },
  {
    name: "settings-customerPackageSelector",
    path: "/settings/customerPackageSelector",
    component: () => import("/home/staging/git/fluent-ui/apps/backpack/src/pages/settings/customerPackageSelector.vue")
  },
  {
    name: component_45stub3ce9d6BLMR4br3dwmImQ8nV6mBz6xVxIGsx6zr40rXwMeta?.name,
    path: "/setup/start",
    component: component_45stub3ce9d6BLMR4br3dwmImQ8nV6mBz6xVxIGsx6zr40rXw
  },
  {
    name: component_45stub3ce9d6BLMR4br3dwmImQ8nV6mBz6xVxIGsx6zr40rXwMeta?.name,
    path: "/setup/connect",
    component: component_45stub3ce9d6BLMR4br3dwmImQ8nV6mBz6xVxIGsx6zr40rXw
  },
  {
    name: component_45stub3ce9d6BLMR4br3dwmImQ8nV6mBz6xVxIGsx6zr40rXwMeta?.name,
    path: "/setup/csv",
    component: component_45stub3ce9d6BLMR4br3dwmImQ8nV6mBz6xVxIGsx6zr40rXw
  }
]